import { useConfirmNavigateAway } from '@automata/utils/hooks';

import {
  selectWorkflowIsDeleted,
  selectWorkflowIsSaved,
} from '../features/ui/selectors';
import { useAppSelector } from '../hooks';

export const useInitializeConfirmNavigateAway = () => {
  const workflowIsSaved = useAppSelector(selectWorkflowIsSaved);

  const workflowIsDeleted = useAppSelector(selectWorkflowIsDeleted);

  useConfirmNavigateAway((router, newRoute) => {
    if (workflowIsDeleted) return false;
    if (!newRoute) return !workflowIsSaved;

    const [asPathWithoutQuery = ''] = router.asPath.split('?');
    const [newRouteWithoutQuery = ''] = newRoute.split('?');
    if (asPathWithoutQuery === newRouteWithoutQuery) return false;

    const isEditPage = /canvas-workflows\/([A-Za-z0-9\-]+)([\/]*)/;
    const isNavigationWithinEditPage =
      asPathWithoutQuery.match(isEditPage) &&
      newRouteWithoutQuery.match(isEditPage);
    if (isNavigationWithinEditPage) return false;

    return !workflowIsSaved;
  });
};
